import { render, staticRenderFns } from "./MajorTable.vue?vue&type=template&id=2d176db9"
import script from "./MajorTable.vue?vue&type=script&lang=js"
export * from "./MajorTable.vue?vue&type=script&lang=js"
import style0 from "./MajorTable.vue?vue&type=style&index=0&id=2d176db9&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports